export const SET_HOT_PRIMARY_CATELIST = 'SET_HOT_PRIMARY_CATELIST';
export const SET_HOT_PRODUCT_LIST = 'SET_HOT_PRODUCT_LIST';
export const RESET_HOT_PRODUCT_LIST = 'RESET_HOT_PRODUCT_LIST';

export const SET_HOT_PRODUCT_FILTER = 'SET_HOT_PRODUCT_FILTER';
export const RESET_HOT_PRODUCT_FILTER = 'RESET_HOT_PRODUCT_FILTER';

export const SET_HOT_PRODUCT_LIST_PAGE_NUM = 'SET_HOT_PRODUCT_LIST_PAGE_NUM';
export const SET_HOT_PRODUCT_LIST_PAGE_COUNT = 'SET_HOT_PRODUCT_LIST_PAGE_COUNT';

export const SET_HOT_TAB_LIST = 'SET_HOT_TAB_LIST';
export const SET_HOT_MEDIA_INFO = 'SET_HOT_MEDIA_INFO';

export const SET_GOOD_POOL_TAB_LIST = 'SET_GOOD_POOL_TAB_LIST';
export const SET_SHOPPING_GUILD = 'SET_SHOPPING_GUILD';

export const SET_TAB_TYPE = 'SET_TAB_TYPE';

export const SET_NO_MORE = 'SET_NO_MORE';
export const SET_LOADING = 'SET_LOADING';

export const SET_TOTAL = 'SET_TOTAL';

export const SET_XEPP_SHOPID = 'SET_XEPP_SHOPID';
export const SET_HAS_OM = 'SET_HAS_OM';
export const SET_OM = 'SET_OM';
